import { getIsAdminFromStore } from 'lib/helper';
import superagent from 'superagent';
import config from '../config';
import store from '../redux/store';
import { registerApiRequest } from './requestCancellation';

/*
 * @function 'call' common method that makes api requests
 * @param {object} 'request' stores the request 'method','endpoint', 'payload', 'query',
 * 'token' as keys...'
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const apiCall = (apiData: {
  method: 'get' | 'put' | 'post' | 'delete' | 'patch';
  url?: string;
  endpoint?: string;
  payload?;
  query?;
  customOrigin?: string;
  sf_access_token?: string;
  sf_token_type?: string;
  cm_access_token?: string;
  cm_token_type?: string;
  signzy_token?: string;
  type?: string;
  requestType?: 'json' | 'image';
  isAuthEndPoint?: boolean;
  isPayoutsEndpoint?: boolean;
  isPlanEndpoint?: boolean;
  isSalesForceEndPoint?: boolean;
  isCompleteProfile?: boolean;
  isSalesForceOAuth?: boolean;
  isCaseManagementEndPoint?: boolean;
  isSignzyEndPoint?: boolean;
  isKYCVerifyEndPoint?: boolean;
  isPreview?: boolean;
  formData?: FormData;
  isDownloadZip?: boolean;
  isDownloadXlsx?: boolean;
  isDownloadCsv?: boolean;
  isWebhookEndPoint?: boolean;
  isOnboardingEndPoint?: boolean;
  headers?: Record<string, string>;
  isV3Header?: boolean;
  cancelKey?: string;
}) => {
  const {
    method = 'get',
    url,
    endpoint,
    payload,
    query,
    customOrigin = '',
    sf_access_token,
    sf_token_type,
    cm_access_token,
    cm_token_type,
    signzy_token,
    // type = 'application/json',
    formData = null,
    requestType = 'json',
    isAuthEndPoint = false,
    isPayoutsEndpoint = false,
    isDownloadZip = false,
    isPlanEndpoint = false,
    isSalesForceEndPoint = false,
    isCaseManagementEndPoint = false,
    isSignzyEndPoint = false,
    isKYCVerifyEndPoint = false,
    isPreview = false,
    isDownloadXlsx = false,
    isDownloadCsv = false,
    isWebhookEndPoint = false,
    isOnboardingEndPoint = false,
    headers = {},
    isV3Header = false,
    cancelKey,
  } = apiData;

  let _url = '';
  if (isAuthEndPoint) {
    _url = `${config().API.API_AUTH_URL}/${endpoint}`;
  } else if (isPayoutsEndpoint) {
    _url = `${config().API.API_PAYOUTS_URL}/${endpoint}`;
  } else if (isSalesForceEndPoint && customOrigin && customOrigin !== '') {
    _url = `${customOrigin}/${endpoint}`;
  } else if (isCaseManagementEndPoint) {
    _url = `${config().API.API_CASE_MANAGEMENT_URL}/${endpoint}`;
  } else if (isSignzyEndPoint) {
    _url = `${config().API.API_SIGNZY_URL}/${endpoint}`;
  } else if (isKYCVerifyEndPoint) {
    _url = `${config().API.API_VERIFY_KYC_URL}/${endpoint}`;
  } else if (customOrigin && customOrigin !== '') {
    _url = `${customOrigin}/${endpoint}`;
  } else if (isOnboardingEndPoint) {
    _url = `${config().API.API_ONBOARDING_BASE_URL}/${endpoint}`;
  } else {
    _url = `${config().API.API_BASE_URL}/${endpoint}`;
  }

  const isAdmin = getIsAdminFromStore();
  const authToken = store.getState().loginReducer.loginState.token;
  const request = superagent(method, endpoint ? _url : url);

  let apiQuery = query;
  let apiPayload = payload;
  if (requestType !== 'image') {
    // request.set('Content-Type', type);
  }
  if (authToken) {
    request.set('Authorization', `Bearer ${authToken}`);
  }

  if (isSalesForceEndPoint) {
    request.set('Authorization', `${sf_token_type} ${sf_access_token}`);
  }

  if (isV3Header) {
    request.set('version', 'v3');
  }

  if (isCaseManagementEndPoint) {
    request.set('Authorization', `${cm_token_type} ${cm_access_token}`);
  }

  if (isSignzyEndPoint) {
    request.set('Authorization', `${signzy_token}`);
  }

  if (isWebhookEndPoint) {
    request.set('X-Api-Key', config().API.API_WEBHOOK_KEY);
  }

  if (isDownloadZip || isPreview) {
    request.set('content-type', 'application/json');
    request.responseType('arraybuffer');
  }

  if (isDownloadXlsx) {
    request.set('content-type', 'blob');
    request.responseType('arraybuffer');
  }
  
  if (headers) {
    Object.entries(headers).forEach(([key, value]) => {
      request.set(key, value);
    });
  }

  if (isPayoutsEndpoint) {
    // append isAdmin to payload or query if payload or query exist and they dont have isAdmin.
    if (apiQuery && Object.entries(apiQuery).length > 0) {
      if (apiQuery['isAdmin'] === undefined) {
        apiQuery['isAdmin'] = isAdmin;
      }
    } else {
      apiQuery = {
        isAdmin,
      };
    }
    if (apiPayload && Object.entries(apiPayload).length > 0) {
      if (apiPayload['isAdmin'] === undefined) {
        apiPayload['isAdmin'] = isAdmin;
      }
    } else {
      apiPayload = {
        isAdmin,
      };
    }
  }

  if(isPlanEndpoint) {
    request.set('Merchant-ID', store.getState().loginReducer?.loginState?.merchantId);
  }

  const apiRequest = formData
    ? request.send(formData).withCredentials().query(apiQuery)
    : request.send(apiPayload).withCredentials().query(apiQuery);

  registerApiRequest(cancelKey, apiRequest);

  return apiRequest;
};

export default apiCall;
